import React, { Component } from 'react';
import { connect } from 'react-redux';
import { search } from '../actions/appearanceSearchAction';
import { Container, Dimmer, Loader, Card, Pagination, Segment } from 'semantic-ui-react';
import AppearanceCard from '../../common/appearances/AppearanceCard';
import AppearanceSearchForm from './AppearanceSearchForm';

class AppearanceIndexComponent extends Component {

    static LIMIT = 48;

    componentDidMount() {
        const {parameters} = this.props.appearanceSearch;
        this.props.search(parameters);
    }

    onSearchClick = (values) => {

        this.props.search({
            text: values.text,
            types: values.types,
            slots: values.slots,
            tags: values.tags,
            skip: 0,
            limit: AppearanceIndexComponent.LIMIT,
        });
    }

    onPageChange = (e, data) => {
        const {parameters} = this.props.appearanceSearch;

        this.props.search({
            text: parameters.text,
            types: parameters.types,
            slots: parameters.slots,
            tags: parameters.tags,
            skip: (data.activePage - 1) * AppearanceIndexComponent.LIMIT,
            limit: AppearanceIndexComponent.LIMIT,
        });
    }

    render() {

        const {isFetching} = this.props;
        const {appearances, page, pages} = this.props.appearanceSearch.results;

        const pagination = pages > 1 ? <Pagination totalPages={pages} activePage={page} onPageChange={this.onPageChange} /> : <div />;

        return (
            <Container>
                <Dimmer active={isFetching}>
                    <Loader>Loading appearances</Loader>
                </Dimmer>

                <Segment>
                    <AppearanceSearchForm onSubmit={this.onSearchClick} />
                </Segment>
                <Segment>
                    <Card.Group centered itemsPerRow={3} doubling stackable>
                        {appearances.map( a => <AppearanceCard appearance={a} />)}
                    </Card.Group>
                </Segment>

                {pagination}
            </Container>
        )
    }
}

const mapStateToProps = state => ({
    appearanceSearch: state.appearanceSearch,
    isFetching: state.appearanceSearch.isFetching,
});

const mapDispatchToProps = () => ({
    search,
});

export default connect(mapStateToProps, mapDispatchToProps())(AppearanceIndexComponent);


// WEBPACK FOOTER //
// ./src/appearances/index/AppearanceIndexComponent.jsx